<template>
  <f7-page
    class="repair-parts-details"
    :page-content="false"
  >
    <template #fixed>
      <TheNavbar
        nav-title="Detalles del parte"
        :back-btn-enable="true"
        :back-callback="goBack"
        class="at-navbar secondary-navbar"
      />
    </template>

    <f7-page-content>
      <UCPreload
        :show="fetchingDetails"
        :number="3"
      />

      <PCPartsDetailsCard v-if="!fetchingDetails" />
    </f7-page-content>
  </f7-page>
</template>

<script setup>
// @ts-check

import { onMounted, ref } from 'vue';
import { useRepairParts } from '@/composables/useRepairParts';
import { f7 } from 'framework7-vue';

import TheNavbar from '@/components/TheNavbar.vue';
import UCPreload from '@/components/common/UCPreload.vue';
import PCPartsDetailsCard from '@/components/repairs/repairParts/details/PCPartsDetailsCard.vue';

const props = defineProps({
  workPartId: { type: Number, required: true },
});

const fetchingDetails = ref(true);

const {
  workPartDetails,
  loadWorkParts,
  fetchWorkPartDetails,
} = useRepairParts();

function goBack() {
  f7.views.main.router.back();
  loadWorkParts();
}

onMounted(async () => {
  try {
    await fetchWorkPartDetails(props.workPartId);
  } finally {
    if (!workPartDetails.value) {
      goBack();
    }

    fetchingDetails.value = false;
  }
});
</script>
